// // src/pages/user/ServiceDetail.jsx
// import React, { useState, useEffect } from 'react';
// import { useParams, Link, useNavigate } from 'react-router-dom';
// import { getService } from '../../utils/api';
// import { FaArrowLeft, FaPhone, FaEnvelope, FaCheckCircle } from 'react-icons/fa';
// import toast from 'react-hot-toast';

// const ServiceDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [service, setService] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     loadServiceDetails();
//   }, [id]);

//   const loadServiceDetails = async () => {
//     try {
//       setLoading(true);
//       const data = await getService(id);
//       console.log('Service detail loaded:', data);
      
//       if (data) {
//         setService(data);
//       } else {
//         toast.error('Service not found');
//         navigate('/services');
//       }
//     } catch (error) {
//       console.error('Error loading service details:', error);
//       toast.error('Failed to load service details');
//       navigate('/services');
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading service details...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!service) {
//     return (
//       <div className="min-h-screen bg-gray-50 py-12">
//         <div className="container mx-auto px-4 text-center">
//           <h1 className="text-3xl font-bold text-gray-800 mb-4">Service Not Found</h1>
//           <p className="text-gray-600 mb-6">The service you're looking for doesn't exist.</p>
//           <Link to="/services" className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold">
//             <FaArrowLeft className="mr-2" />
//             Back to Services
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Breadcrumb */}
//       <div className="bg-white border-b">
//         <div className="container mx-auto px-4 py-4">
//           <nav className="flex items-center text-sm text-gray-600">
//             <Link to="/" className="hover:text-blue-600">Home</Link>
//             <span className="mx-2">/</span>
//             <Link to="/services" className="hover:text-blue-600">Services</Link>
//             <span className="mx-2">/</span>
//             <span className="text-gray-800 font-medium truncate">{service.title}</span>
//           </nav>
//         </div>
//       </div>

//       <div className="container mx-auto px-4 py-8">
//         <div className="bg-white rounded-xl shadow-lg overflow-hidden">
//           {/* Header */}
//           <div className="p-6 border-b">
//             <Link 
//               to="/services" 
//               className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-4"
//             >
//               <FaArrowLeft className="mr-2" />
//               Back to Services
//             </Link>
//             <h1 className="text-3xl font-bold text-gray-800">{service.title}</h1>
//             <div className="flex items-center mt-2">
//               <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
//                 {service.category}
//               </span>
//               {service.is_active === false && (
//                 <span className="ml-2 px-2 py-1 bg-red-100 text-red-800 text-xs rounded">
//                   Inactive
//                 </span>
//               )}
//             </div>
//           </div>

//           {/* Content */}
//           <div className="p-6">
//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//               {/* Left Column */}
//               <div className="lg:col-span-2">
//                 {/* Image */}
//                 {service.image_url && (
//                   <div className="mb-6">
//                     <img 
//                       src={service.image_url} 
//                       alt={service.title}
//                       className="w-full h-64 md:h-80 object-cover rounded-lg"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.src = '/default-service.jpg';
//                       }}
//                     />
//                   </div>
//                 )}

//                 {/* Description */}
//                 <div className="mb-8">
//                   <h2 className="text-2xl font-bold text-gray-800 mb-4">Description</h2>
//                   <p className="text-gray-700 whitespace-pre-line">
//                     {service.description || 'No description available.'}
//                   </p>
//                 </div>

//                 {/* Service Details */}
//                 {service.details?.services?.length > 0 && (
//                   <div className="mb-8">
//                     <h2 className="text-2xl font-bold text-gray-800 mb-4">Service Details</h2>
//                     <ul className="space-y-3">
//                       {service.details.services.map((item, index) => (
//                         <li key={index} className="flex items-start">
//                           <FaCheckCircle className="h-5 w-5 text-green-500 mr-3 mt-1 flex-shrink-0" />
//                           <span className="text-gray-700">{item}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}
//               </div>

//               {/* Right Column - Sidebar */}
//               <div className="space-y-6">
//                 {/* Contact Card */}
//                 <div className="bg-blue-50 rounded-lg p-6">
//                   <h3 className="text-xl font-bold text-gray-800 mb-4">Get a Quote</h3>
//                   <p className="text-gray-600 mb-4">
//                     Interested in this service? Contact us for more information.
//                   </p>
//                   <div className="space-y-3">
//                     <a 
//                       href="tel:+260 966 801 731" 
//                       className="flex items-center text-blue-600 hover:text-blue-800"
//                     >
//                       <FaPhone className="mr-3" />
//                       <span>+260 966 801 731</span>
//                     </a>
//                     <a 
//                       href="brasotechinvestments@gmail.com" 
//                       className="flex items-center text-blue-600 hover:text-blue-800"
//                     >
//                       <FaEnvelope className="mr-3" />
//                       <span>brasotechinvestments@gmail.com</span>
//                     </a>
//                   </div>
//                   <a 
//                     href="/contact" 
//                     className="block w-full mt-4 bg-blue-600 text-white text-center py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
//                   >
//                     Contact Us
//                   </a>
//                 </div>

//                 {/* Quick Info */}
//                 <div className="bg-gray-50 rounded-lg p-6">
//                   <h3 className="text-xl font-bold text-gray-800 mb-4">Quick Info</h3>
//                   <div className="space-y-3">
//                     <div>
//                       <span className="text-sm text-gray-500">Category:</span>
//                       <p className="font-medium">{service.category}</p>
//                     </div>
//                     <div>
//                       <span className="text-sm text-gray-500">Status:</span>
//                       <p className="font-medium">
//                         {service.is_active ? 'Active' : 'Inactive'}
//                       </p>
//                     </div>
//                     {service.created_at && (
//                       <div>
//                         <span className="text-sm text-gray-500">Added:</span>
//                         <p className="font-medium">
//                           {new Date(service.created_at).toLocaleDateString()}
//                         </p>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServiceDetail;




// import React, { useState, useEffect } from 'react';
// import { useParams, Link, useNavigate } from 'react-router-dom';
// import { getService } from '../../utils/api';
// import { 
//   FaArrowLeft, 
//   FaPhone, 
//   FaEnvelope, 
//   FaCheckCircle, 
//   FaImage,
//   FaStar,
//   FaExpand,
//   FaChevronLeft,
//   FaChevronRight
// } from 'react-icons/fa';
// import toast from 'react-hot-toast';

// const ServiceDetail = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [service, setService] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(0);
//   const [showLightbox, setShowLightbox] = useState(false);
//   const [details, setDetails] = useState({ services: [], additionalImages: [] });

//   useEffect(() => {
//     loadServiceDetails();
//   }, [id]);

//   const loadServiceDetails = async () => {
//     try {
//       setLoading(true);
//       const data = await getService(id);
//       console.log('Service detail loaded:', data);
      
//       if (data) {
//         setService(data);
        
//         // Parse service details
//         let parsedDetails = data.details;
//         if (typeof parsedDetails === 'string') {
//           try {
//             parsedDetails = JSON.parse(parsedDetails);
//           } catch (e) {
//             console.error('Error parsing service details:', e);
//             parsedDetails = { services: [], additionalImages: [] };
//           }
//         }
        
//         // Ensure arrays exist
//         if (!parsedDetails.services) parsedDetails.services = [];
//         if (!parsedDetails.additionalImages) parsedDetails.additionalImages = [];
        
//         setDetails(parsedDetails);
//       } else {
//         toast.error('Service not found');
//         navigate('/services');
//       }
//     } catch (error) {
//       console.error('Error loading service details:', error);
//       toast.error('Failed to load service details');
//       navigate('/services');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Function to handle image navigation
//   const nextImage = () => {
//     if (details.additionalImages.length > 0) {
//       setSelectedImageIndex((prevIndex) => 
//         prevIndex === details.additionalImages.length - 1 ? 0 : prevIndex + 1
//       );
//     }
//   };

//   const prevImage = () => {
//     if (details.additionalImages.length > 0) {
//       setSelectedImageIndex((prevIndex) => 
//         prevIndex === 0 ? details.additionalImages.length - 1 : prevIndex - 1
//       );
//     }
//   };

//   // Function to open lightbox
//   const openLightbox = (index) => {
//     setSelectedImageIndex(index);
//     setShowLightbox(true);
//   };

//   // Close lightbox
//   const closeLightbox = () => {
//     setShowLightbox(false);
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading service details...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!service) {
//     return (
//       <div className="min-h-screen bg-gray-50 py-12">
//         <div className="container mx-auto px-4 text-center">
//           <h1 className="text-3xl font-bold text-gray-800 mb-4">Service Not Found</h1>
//           <p className="text-gray-600 mb-6">The service you're looking for doesn't exist.</p>
//           <Link to="/services" className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold">
//             <FaArrowLeft className="mr-2" />
//             Back to Services
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Breadcrumb */}
//       <div className="bg-white border-b">
//         <div className="container mx-auto px-4 py-4">
//           <nav className="flex items-center text-sm text-gray-600">
//             <Link to="/" className="hover:text-blue-600">Home</Link>
//             <span className="mx-2">/</span>
//             <Link to="/services" className="hover:text-blue-600">Services</Link>
//             <span className="mx-2">/</span>
//             <span className="text-gray-800 font-medium truncate">{service.title}</span>
//           </nav>
//         </div>
//       </div>

//       <div className="container mx-auto px-4 py-8">
//         <div className="bg-white rounded-xl shadow-lg overflow-hidden">
//           {/* Header */}
//           <div className="p-6 border-b">
//             <Link 
//               to="/services" 
//               className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-4"
//             >
//               <FaArrowLeft className="mr-2" />
//               Back to Services
//             </Link>
//             <h1 className="text-3xl font-bold text-gray-800">{service.title}</h1>
//             <div className="flex items-center mt-2">
//               <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
//                 {service.category}
//               </span>
//               {service.is_active === false && (
//                 <span className="ml-2 px-2 py-1 bg-red-100 text-red-800 text-xs rounded">
//                   Inactive
//                 </span>
//               )}
//             </div>
//           </div>

//           {/* Content */}
//           <div className="p-6">
//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//               {/* Left Column - Main Content */}
//               <div className="lg:col-span-2">
//                 {/* Main Image */}
//                 {service.image_url && (
//                   <div className="mb-6 relative">
//                     <img 
//                       src={service.image_url} 
//                       alt={service.title}
//                       className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.src = '/default-service.jpg';
//                       }}
//                     />
//                     <div className="absolute top-4 right-4 bg-black bg-opacity-50 text-white text-xs px-3 py-1 rounded-full flex items-center">
//                       <FaStar className="mr-1" />
//                       Main Image
//                     </div>
//                   </div>
//                 )}

//                 {/* Description */}
//                 <div className="mb-8">
//                   <h2 className="text-2xl font-bold text-gray-800 mb-4">Description</h2>
//                   <p className="text-gray-700 whitespace-pre-line">
//                     {service.description || 'No description available.'}
//                   </p>
//                 </div>

//                 {/* Service Items */}
//                 {details.services.length > 0 && (
//                   <div className="mb-8">
//                     <h2 className="text-2xl font-bold text-gray-800 mb-4">Service Details</h2>
//                     <ul className="space-y-3">
//                       {details.services.map((item, index) => (
//                         <li key={index} className="flex items-start">
//                           <FaCheckCircle className="h-5 w-5 text-green-500 mr-3 mt-1 flex-shrink-0" />
//                           <span className="text-gray-700">{item}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}

//                 {/* Additional Images Gallery */}
//                 {details.additionalImages.length > 0 && (
//                   <div className="mb-8">
//                     <div className="flex justify-between items-center mb-6">
//                       <h2 className="text-2xl font-bold text-gray-800">Gallery</h2>
//                       <span className="text-gray-500 text-sm">
//                         {details.additionalImages.length} image{details.additionalImages.length !== 1 ? 's' : ''}
//                       </span>
//                     </div>
                    
//                     {/* Selected Image Display */}
//                     <div className="mb-6 bg-gray-50 rounded-lg p-4">
//                       <div className="relative mb-4">
//                         <img 
//                           src={details.additionalImages[selectedImageIndex].url} 
//                           alt={details.additionalImages[selectedImageIndex].subtitle || `Service image ${selectedImageIndex + 1}`}
//                           className="w-full h-64 md:h-80 object-cover rounded-lg cursor-pointer"
//                           onClick={() => openLightbox(selectedImageIndex)}
//                         />
//                         <button
//                           onClick={() => openLightbox(selectedImageIndex)}
//                           className="absolute top-4 right-4 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-70 transition-all"
//                           title="Expand image"
//                         >
//                           <FaExpand className="h-4 w-4" />
//                         </button>
//                         {details.additionalImages[selectedImageIndex].is_primary && (
//                           <div className="absolute top-4 left-4 bg-green-500 text-white text-xs px-3 py-1 rounded-full flex items-center">
//                             <FaStar className="mr-1" />
//                             Primary
//                           </div>
//                         )}
//                       </div>
                      
//                       {/* Image Details */}
//                       <div className="space-y-2">
//                         {details.additionalImages[selectedImageIndex].subtitle && (
//                           <h3 className="text-xl font-semibold text-gray-800">
//                             {details.additionalImages[selectedImageIndex].subtitle}
//                           </h3>
//                         )}
//                         {details.additionalImages[selectedImageIndex].description && (
//                           <p className="text-gray-600">
//                             {details.additionalImages[selectedImageIndex].description}
//                           </p>
//                         )}
//                       </div>
//                     </div>

//                     {/* Thumbnail Navigation */}
//                     <div className="mb-6">
//                       <h3 className="text-lg font-semibold text-gray-800 mb-3">All Images</h3>
//                       <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//                         {details.additionalImages.map((image, index) => (
//                           <div 
//                             key={index} 
//                             className={`relative cursor-pointer rounded-lg overflow-hidden border-2 transition-all ${
//                               selectedImageIndex === index 
//                                 ? 'border-blue-500 shadow-md' 
//                                 : 'border-transparent hover:border-gray-300'
//                             }`}
//                             onClick={() => setSelectedImageIndex(index)}
//                           >
//                             <img 
//                               src={image.url} 
//                               alt={image.subtitle || `Image ${index + 1}`}
//                               className="w-full h-32 object-cover"
//                             />
//                             <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
//                               <span className="text-white text-xs font-medium opacity-0 hover:opacity-100 transition-opacity">
//                                 View
//                               </span>
//                             </div>
//                             {image.is_primary && (
//                               <div className="absolute top-2 left-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full">
//                                 <FaStar className="h-3 w-3" />
//                               </div>
//                             )}
//                           </div>
//                         ))}
//                       </div>
//                     </div>

//                     {/* Navigation Controls */}
//                     <div className="flex justify-center space-x-4">
//                       <button
//                         onClick={prevImage}
//                         className="flex items-center px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
//                       >
//                         <FaChevronLeft className="mr-2" />
//                         Previous
//                       </button>
//                       <button
//                         onClick={nextImage}
//                         className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
//                       >
//                         Next
//                         <FaChevronRight className="ml-2" />
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               {/* Right Column - Sidebar */}
//               <div className="space-y-6">
//                 {/* Contact Card */}
//                 <div className="bg-blue-50 rounded-lg p-6">
//                   <h3 className="text-xl font-bold text-gray-800 mb-4">Get a Quote</h3>
//                   <p className="text-gray-600 mb-4">
//                     Interested in this service? Contact us for more information.
//                   </p>
//                   <div className="space-y-3">
//                     <a 
//                       href="tel:+260966801731" 
//                       className="flex items-center text-blue-600 hover:text-blue-800"
//                     >
//                       <FaPhone className="mr-3" />
//                       <span>+260 966 801 731</span>
//                     </a>
//                     <a 
//                       href="mailto:brasotechinvestments@gmail.com" 
//                       className="flex items-center text-blue-600 hover:text-blue-800"
//                     >
//                       <FaEnvelope className="mr-3" />
//                       <span>brasotechinvestments@gmail.com</span>
//                     </a>
//                   </div>
//                   <a 
//                     href="/contact" 
//                     className="block w-full mt-4 bg-blue-600 text-white text-center py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
//                   >
//                     Contact Us
//                   </a>
//                 </div>

//                 {/* Quick Info */}
//                 <div className="bg-gray-50 rounded-lg p-6">
//                   <h3 className="text-xl font-bold text-gray-800 mb-4">Quick Info</h3>
//                   <div className="space-y-3">
//                     <div>
//                       <span className="text-sm text-gray-500">Category:</span>
//                       <p className="font-medium">{service.category}</p>
//                     </div>
//                     <div>
//                       <span className="text-sm text-gray-500">Status:</span>
//                       <p className={`font-medium ${service.is_active ? 'text-green-600' : 'text-red-600'}`}>
//                         {service.is_active ? 'Active' : 'Inactive'}
//                       </p>
//                     </div>
//                     <div>
//                       <span className="text-sm text-gray-500">Images:</span>
//                       <p className="font-medium">
//                         1 main + {details.additionalImages.length} additional
//                       </p>
//                     </div>
//                     {service.created_at && (
//                       <div>
//                         <span className="text-sm text-gray-500">Added:</span>
//                         <p className="font-medium">
//                           {new Date(service.created_at).toLocaleDateString('en-US', {
//                             year: 'numeric',
//                             month: 'long',
//                             day: 'numeric'
//                           })}
//                         </p>
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* Share Service */}
//                 <div className="bg-green-50 rounded-lg p-6">
//                   <h3 className="text-xl font-bold text-gray-800 mb-4">Share This Service</h3>
//                   <p className="text-gray-600 mb-4">
//                     Know someone who might be interested? Share this service with them.
//                   </p>
//                   <div className="flex space-x-3">
//                     <button className="flex-1 bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 transition-colors">
//                       Facebook
//                     </button>
//                     <button className="flex-1 bg-blue-400 text-white py-2 rounded-lg hover:bg-blue-500 transition-colors">
//                       Twitter
//                     </button>
//                     <button className="flex-1 bg-red-500 text-white py-2 rounded-lg hover:bg-red-600 transition-colors">
//                       WhatsApp
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Lightbox Modal */}
//       {showLightbox && (
//         <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
//           <div className="relative max-w-6xl w-full">
//             {/* Close button */}
//             <button
//               onClick={closeLightbox}
//               className="absolute top-4 right-4 text-white text-2xl z-10 hover:text-gray-300"
//             >
//               ✕
//             </button>
            
//             {/* Navigation buttons */}
//             <button
//               onClick={prevImage}
//               className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white text-3xl hover:text-gray-300"
//             >
//               <FaChevronLeft />
//             </button>
            
//             <button
//               onClick={nextImage}
//               className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white text-3xl hover:text-gray-300"
//             >
//               <FaChevronRight />
//             </button>
            
//             {/* Image */}
//             <div className="flex flex-col items-center">
//               <img 
//                 src={details.additionalImages[selectedImageIndex].url} 
//                 alt={details.additionalImages[selectedImageIndex].subtitle || 'Service image'}
//                 className="max-w-full max-h-[80vh] object-contain"
//               />
              
//               {/* Image details */}
//               <div className="mt-6 text-white text-center max-w-2xl">
//                 {details.additionalImages[selectedImageIndex].subtitle && (
//                   <h3 className="text-2xl font-bold mb-2">
//                     {details.additionalImages[selectedImageIndex].subtitle}
//                   </h3>
//                 )}
//                 {details.additionalImages[selectedImageIndex].description && (
//                   <p className="text-lg">
//                     {details.additionalImages[selectedImageIndex].description}
//                   </p>
//                 )}
//                 <div className="mt-4 text-gray-300">
//                   Image {selectedImageIndex + 1} of {details.additionalImages.length}
//                   {details.additionalImages[selectedImageIndex].is_primary && (
//                     <span className="ml-4 text-green-400">
//                       <FaStar className="inline mr-1" />
//                       Primary Image
//                     </span>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ServiceDetail;



import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getService } from '../../utils/api';
import { 
  FaArrowLeft, 
  FaPhone, 
  FaEnvelope, 
  FaCheckCircle, 
  FaImage,
  FaStar,
  FaExpand,
  FaChevronLeft,
  FaChevronRight,
  FaFacebook,
  FaTwitter,
  FaWhatsapp
} from 'react-icons/fa';
import toast from 'react-hot-toast';

const ServiceDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [showLightbox, setShowLightbox] = useState(false);
  const [details, setDetails] = useState({ services: [], additionalImages: [] });

  useEffect(() => {
    loadServiceDetails();
  }, [id]);

  // Share functions
  const shareOnFacebook = () => {
    if (!service) return;
    
    const url = window.location.href;
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=400');
    toast.success('Opening Facebook share...');
  };

  const shareOnTwitter = () => {
    if (!service) return;
    
    const url = window.location.href;
    const text = `Check out "${service.title}" service from Brasotech Investments`;
    const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
    window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=400');
    toast.success('Opening Twitter...');
  };

  const shareOnWhatsApp = () => {
    if (!service) return;
    
    const url = window.location.href;
    const text = `Check out "${service.title}" service from Brasotech Investments: ${url}`;
    
    // Check if it's mobile device
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // Mobile - use WhatsApp protocol
      window.open(`whatsapp://send?text=${encodeURIComponent(text)}`, '_blank');
    } else {
      // Desktop - use web WhatsApp
      window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer,width=600,height=400');
    }
    toast.success('Opening WhatsApp...');
  };

  // Web Share API function
  const handleNativeShare = async () => {
    if (!service) return;
    
    if (navigator.share) {
      try {
        await navigator.share({
          title: service.title,
          text: `Check out "${service.title}" service from Brasotech Investments`,
          url: window.location.href,
        });
        toast.success('Shared successfully!');
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.log('Error sharing:', error);
        }
      }
    } else {
      // Fallback: copy to clipboard
      navigator.clipboard.writeText(window.location.href).then(() => {
        toast.success('Link copied to clipboard!');
      });
    }
  };

  const loadServiceDetails = async () => {
    try {
      setLoading(true);
      const data = await getService(id);
      console.log('Service detail loaded:', data);
      
      if (data) {
        setService(data);
        
        // Parse service details
        let parsedDetails = data.details;
        if (typeof parsedDetails === 'string') {
          try {
            parsedDetails = JSON.parse(parsedDetails);
          } catch (e) {
            console.error('Error parsing service details:', e);
            parsedDetails = { services: [], additionalImages: [] };
          }
        }
        
        // Ensure arrays exist
        if (!parsedDetails.services) parsedDetails.services = [];
        if (!parsedDetails.additionalImages) parsedDetails.additionalImages = [];
        
        setDetails(parsedDetails);
      } else {
        toast.error('Service not found');
        navigate('/services');
      }
    } catch (error) {
      console.error('Error loading service details:', error);
      toast.error('Failed to load service details');
      navigate('/services');
    } finally {
      setLoading(false);
    }
  };

  // Function to handle image navigation
  const nextImage = () => {
    if (details.additionalImages.length > 0) {
      setSelectedImageIndex((prevIndex) => 
        prevIndex === details.additionalImages.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  const prevImage = () => {
    if (details.additionalImages.length > 0) {
      setSelectedImageIndex((prevIndex) => 
        prevIndex === 0 ? details.additionalImages.length - 1 : prevIndex - 1
      );
    }
  };

  // Function to open lightbox
  const openLightbox = (index) => {
    setSelectedImageIndex(index);
    setShowLightbox(true);
  };

  // Close lightbox
  const closeLightbox = () => {
    setShowLightbox(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading service details...</p>
        </div>
      </div>
    );
  }

  if (!service) {
    return (
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl font-bold text-gray-800 mb-4">Service Not Found</h1>
          <p className="text-gray-600 mb-6">The service you're looking for doesn't exist.</p>
          <Link to="/services" className="inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold">
            <FaArrowLeft className="mr-2" />
            Back to Services
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Breadcrumb */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-4">
          <nav className="flex items-center text-sm text-gray-600">
            <Link to="/" className="hover:text-blue-600">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/services" className="hover:text-blue-600">Services</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-800 font-medium truncate">{service.title}</span>
          </nav>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          {/* Header */}
          <div className="p-6 border-b">
            <Link 
              to="/services" 
              className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-4"
            >
              <FaArrowLeft className="mr-2" />
              Back to Services
            </Link>
            <h1 className="text-3xl font-bold text-gray-800">{service.title}</h1>
            <div className="flex items-center mt-2">
              <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
                {service.category}
              </span>
              {service.is_active === false && (
                <span className="ml-2 px-2 py-1 bg-red-100 text-red-800 text-xs rounded">
                  Inactive
                </span>
              )}
            </div>
          </div>

          {/* Content */}
          <div className="p-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Left Column - Main Content */}
              <div className="lg:col-span-2">
                {/* Main Image */}
                {service.image_url && (
                  <div className="mb-6 relative">
                    <img 
                      src={service.image_url} 
                      alt={service.title}
                      className="w-full h-64 md:h-80 object-cover rounded-lg shadow-lg"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/default-service.jpg';
                      }}
                    />
                    <div className="absolute top-4 right-4 bg-black bg-opacity-50 text-white text-xs px-3 py-1 rounded-full flex items-center">
                      <FaStar className="mr-1" />
                      Main Image
                    </div>
                  </div>
                )}

                {/* Description */}
                <div className="mb-8">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4">Description</h2>
                  <p className="text-gray-700 whitespace-pre-line">
                    {service.description || 'No description available.'}
                  </p>
                </div>

                {/* Service Items */}
                {details.services.length > 0 && (
                  <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">Service Details</h2>
                    <ul className="space-y-3">
                      {details.services.map((item, index) => (
                        <li key={index} className="flex items-start">
                          <FaCheckCircle className="h-5 w-5 text-green-500 mr-3 mt-1 flex-shrink-0" />
                          <span className="text-gray-700">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Additional Images Gallery */}
                {details.additionalImages.length > 0 && (
                  <div className="mb-8">
                    <div className="flex justify-between items-center mb-6">
                      <h2 className="text-2xl font-bold text-gray-800">Gallery</h2>
                      <span className="text-gray-500 text-sm">
                        {details.additionalImages.length} image{details.additionalImages.length !== 1 ? 's' : ''}
                      </span>
                    </div>
                    
                    {/* Selected Image Display */}
                    <div className="mb-6 bg-gray-50 rounded-lg p-4">
                      <div className="relative mb-4">
                        <img 
                          src={details.additionalImages[selectedImageIndex].url} 
                          alt={details.additionalImages[selectedImageIndex].subtitle || `Service image ${selectedImageIndex + 1}`}
                          className="w-full h-64 md:h-80 object-cover rounded-lg cursor-pointer"
                          onClick={() => openLightbox(selectedImageIndex)}
                        />
                        <button
                          onClick={() => openLightbox(selectedImageIndex)}
                          className="absolute top-4 right-4 bg-black bg-opacity-50 text-white p-2 rounded-full hover:bg-opacity-70 transition-all"
                          title="Expand image"
                        >
                          <FaExpand className="h-4 w-4" />
                        </button>
                        {details.additionalImages[selectedImageIndex].is_primary && (
                          <div className="absolute top-4 left-4 bg-green-500 text-white text-xs px-3 py-1 rounded-full flex items-center">
                            <FaStar className="mr-1" />
                            Primary
                          </div>
                        )}
                      </div>
                      
                      {/* Image Details */}
                      <div className="space-y-2">
                        {details.additionalImages[selectedImageIndex].subtitle && (
                          <h3 className="text-xl font-semibold text-gray-800">
                            {details.additionalImages[selectedImageIndex].subtitle}
                          </h3>
                        )}
                        {details.additionalImages[selectedImageIndex].description && (
                          <p className="text-gray-600">
                            {details.additionalImages[selectedImageIndex].description}
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Thumbnail Navigation */}
                    <div className="mb-6">
                      <h3 className="text-lg font-semibold text-gray-800 mb-3">All Images</h3>
                      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {details.additionalImages.map((image, index) => (
                          <div 
                            key={index} 
                            className={`relative cursor-pointer rounded-lg overflow-hidden border-2 transition-all ${
                              selectedImageIndex === index 
                                ? 'border-blue-500 shadow-md' 
                                : 'border-transparent hover:border-gray-300'
                            }`}
                            onClick={() => setSelectedImageIndex(index)}
                          >
                            <img 
                              src={image.url} 
                              alt={image.subtitle || `Image ${index + 1}`}
                              className="w-full h-32 object-cover"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                              <span className="text-white text-xs font-medium opacity-0 hover:opacity-100 transition-opacity">
                                View
                              </span>
                            </div>
                            {image.is_primary && (
                              <div className="absolute top-2 left-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full">
                                <FaStar className="h-3 w-3" />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Navigation Controls */}
                    <div className="flex justify-center space-x-4">
                      <button
                        onClick={prevImage}
                        className="flex items-center px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
                      >
                        <FaChevronLeft className="mr-2" />
                        Previous
                      </button>
                      <button
                        onClick={nextImage}
                        className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                      >
                        Next
                        <FaChevronRight className="ml-2" />
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Right Column - Sidebar */}
              <div className="space-y-6">
                {/* Contact Card */}
                <div className="bg-blue-50 rounded-lg p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-4">Get a Quote</h3>
                  <p className="text-gray-600 mb-4">
                    Interested in this service? Contact us for more information.
                  </p>
                  <div className="space-y-3">
                    <a 
                      href="tel:+260966801731" 
                      className="flex items-center text-blue-600 hover:text-blue-800"
                    >
                      <FaPhone className="mr-3" />
                      <span>+260 966 801 731</span>
                    </a>
                    <a 
                      href="mailto:brasotechinvestments@gmail.com" 
                      className="flex items-center text-blue-600 hover:text-blue-800"
                    >
                      <FaEnvelope className="mr-3" />
                      <span>brasotechinvestments@gmail.com</span>
                    </a>
                  </div>
                  <a 
                    href="/contact" 
                    className="block w-full mt-4 bg-blue-600 text-white text-center py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
                  >
                    Contact Us
                  </a>
                </div>

                {/* Quick Info */}
                <div className="bg-gray-50 rounded-lg p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-4">Quick Info</h3>
                  <div className="space-y-3">
                    <div>
                      <span className="text-sm text-gray-500">Category:</span>
                      <p className="font-medium">{service.category}</p>
                    </div>
                    <div>
                      <span className="text-sm text-gray-500">Status:</span>
                      <p className={`font-medium ${service.is_active ? 'text-green-600' : 'text-red-600'}`}>
                        {service.is_active ? 'Active' : 'Inactive'}
                      </p>
                    </div>
                    <div>
                      <span className="text-sm text-gray-500">Images:</span>
                      <p className="font-medium">
                        1 main + {details.additionalImages.length} additional
                      </p>
                    </div>
                    {service.created_at && (
                      <div>
                        <span className="text-sm text-gray-500">Added:</span>
                        <p className="font-medium">
                          {new Date(service.created_at).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Share Service */}
                <div className="bg-green-50 rounded-lg p-6">
                  <h3 className="text-xl font-bold text-gray-800 mb-4">Share This Service</h3>
                  <p className="text-gray-600 mb-4">
                    Know someone who might be interested? Share this service with them.
                  </p>
                  <div className="flex space-x-3">
                    <button 
                      onClick={shareOnFacebook}
                      className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg transition-colors flex items-center justify-center"
                    >
                      <FaFacebook className="mr-2" />
                      Share
                    </button>
                    
                    <button 
                      onClick={shareOnTwitter}
                      className="flex-1 bg-blue-400 hover:bg-blue-500 text-white py-2 rounded-lg transition-colors flex items-center justify-center"
                    >
                      <FaTwitter className="mr-2" />
                      Tweet
                    </button>
                    
                    <button 
                      onClick={shareOnWhatsApp}
                      className="flex-1 bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg transition-colors flex items-center justify-center"
                    >
                      <FaWhatsapp className="mr-2" />
                      WhatsApp
                    </button>
                  </div>
                  
                  {/* Native Share Button for Mobile */}
                  {navigator.share && (
                    <button 
                      onClick={handleNativeShare}
                      className="w-full mt-3 bg-purple-600 hover:bg-purple-700 text-white py-2 rounded-lg transition-colors flex items-center justify-center"
                    >
                      <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>
                      </svg>
                      Share via...
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {showLightbox && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
          <div className="relative max-w-6xl w-full">
            {/* Close button */}
            <button
              onClick={closeLightbox}
              className="absolute top-4 right-4 text-white text-2xl z-10 hover:text-gray-300"
            >
              ✕
            </button>
            
            {/* Navigation buttons */}
            <button
              onClick={prevImage}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-white text-3xl hover:text-gray-300"
            >
              <FaChevronLeft />
            </button>
            
            <button
              onClick={nextImage}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white text-3xl hover:text-gray-300"
            >
              <FaChevronRight />
            </button>
            
            {/* Image */}
            <div className="flex flex-col items-center">
              <img 
                src={details.additionalImages[selectedImageIndex].url} 
                alt={details.additionalImages[selectedImageIndex].subtitle || 'Service image'}
                className="max-w-full max-h-[80vh] object-contain"
              />
              
              {/* Image details */}
              <div className="mt-6 text-white text-center max-w-2xl">
                {details.additionalImages[selectedImageIndex].subtitle && (
                  <h3 className="text-2xl font-bold mb-2">
                    {details.additionalImages[selectedImageIndex].subtitle}
                  </h3>
                )}
                {details.additionalImages[selectedImageIndex].description && (
                  <p className="text-lg">
                    {details.additionalImages[selectedImageIndex].description}
                  </p>
                )}
                <div className="mt-4 text-gray-300">
                  Image {selectedImageIndex + 1} of {details.additionalImages.length}
                  {details.additionalImages[selectedImageIndex].is_primary && (
                    <span className="ml-4 text-green-400">
                      <FaStar className="inline mr-1" />
                      Primary Image
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceDetail;